import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { BowMark } from './BowMark';
import { CollectionMockup } from './CollectionMockup';
import { BRAND, OFFER_ANCHOR, PREVIEW_ANCHOR } from '../data/collection';
import { primaryButtonClass, secondaryLinkClass } from '../utils/buttonStyles';

/**
 * Mobile: one centered column — brand, subtitle, title, paragraph, mockup,
 * buttons, support line. Desktop: copy + buttons on the left, mockup right.
 */
export function Hero() {
  return <section id="inicio" aria-labelledby="hero-title" className="w-full bg-ivory" data-id="element-71" data-mp="xanpc0x21jfw">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-5 px-5 pb-10 pt-6 text-center sm:px-8 sm:pt-10 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,1fr)] lg:grid-rows-[auto_auto] lg:gap-x-12 lg:gap-y-8 lg:pb-24 lg:pt-14 lg:text-left" data-id="element-72" data-mp="sbb2hg66ocdb">
        <div className="animate-hero-copy min-w-0 lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-73" data-mp="3d1sayygxbltn">
          <p className="flex items-center justify-center gap-2.5 lg:justify-start lg:gap-3" data-id="element-74" data-mp="3825yir8x69lw">
            <BowMark className="h-7 w-10 shrink-0 lg:h-8 lg:w-12" data-id="element-75" data-mp="3j7zc59vbxccg" />
            <span className="font-serif text-[1.5rem] font-semibold italic leading-none text-coral-ink sm:text-[1.8rem] lg:text-[2rem]" data-id="element-76" data-mp="3j6odtpknkwsq">
              {BRAND.name}
            </span>
          </p>
          <p className="mt-1.5 text-[0.92rem] font-semibold text-sage-ink lg:mt-2 lg:text-[0.95rem]" data-id="element-77" data-mp="39cpbapgo3b09">
            Moldes Multi-talle de ropa infantil
          </p>

          <h1 id="hero-title" className="mt-4 font-serif text-[1.95rem] font-semibold leading-[1.08] text-graphite text-balance min-[390px]:text-[2.15rem] sm:text-[2.8rem] lg:mt-6 lg:text-[3.65rem] lg:leading-[1.04]" data-id="element-78" data-mp="30ggdff8c8kg8">
            Cosé ropa infantil para vestir, regalar o vender.
          </h1>
          <p className="mx-auto mt-3 max-w-xl text-[1rem] leading-relaxed text-graphite-soft text-pretty sm:text-[1.12rem] lg:mx-0 lg:mt-5 lg:text-[1.22rem]" data-id="element-79" data-mp="2vglmxcsh5wvp">
            31 modelos en seis volúmenes, con manuales de confección y moldes Multi-talle para imprimir en A4.
          </p>
        </div>

        <div className="animate-hero-media min-w-0 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-80" data-mp="s3uq3ug3l49k">
          <CollectionMockup priority className="max-w-[min(270px,100%)] sm:max-w-[360px] lg:max-w-[600px]" data-id="element-81" data-mp="ic87ve5ce4xb" />
        </div>

        <div className="min-w-0 lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-82" data-mp="ddne9xklijhu">
          <div className="flex flex-col gap-3 sm:flex-row sm:justify-center lg:justify-start" data-id="element-83" data-mp="1b0w05toidukd">
            <a href={OFFER_ANCHOR} className={primaryButtonClass('hero')} data-id="element-84" data-mp="161t1qs31amld">
              Quiero la colección completa
            </a>
            <a href={PREVIEW_ANCHOR} className={secondaryLinkClass} data-id="element-85" data-mp="111okgzuaxnu3">
              Ver un modelo por dentro
              <ArrowDownIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:translate-y-0.5" aria-hidden data-id="element-86" data-mp="x0crckc7ykh5" />
            </a>
          </div>

          <p className="mt-4 text-[0.92rem] font-semibold text-graphite-soft lg:mt-6 lg:text-[0.95rem]" data-id="element-87" data-mp="3hq24msx9xy7q">
            6 manuales + 6 PDF de moldes <span className="text-coral" aria-hidden data-id="element-88" data-mp="21awdua25atgy">·</span>
            <span className="sr-only" data-id="element-89" data-mp="21bfxpwbcvrxm">,</span> 10 talles por estatura
          </p>
        </div>
      </div>
    </section>;
}